import { render, staticRenderFns } from "./pallet-type.vue?vue&type=template&id=7d87d7ed"
import script from "./pallet-type.vue?vue&type=script&lang=js"
export * from "./pallet-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports